'use client'
import React from 'react'
import { Row } from 'react-bootstrap'
import RelatedContent from './RelatedContent'
import FrequentlyAskedQuestions from './FrequentlyAskedQuestions'

const BlogDescription = ({ data, RelatedContentDatra }) => {
	return (
		<div>
			<div className='blog-details-content-container'>
				<div className='blog-details-content-wapper'>
					<Row className='sun-editor-editable'>
						<div className='table-wapper' dangerouslySetInnerHTML={{ __html: data?.details }} />
					</Row>
				</div>
			</div>
			{!!data?.faq?.length && <FrequentlyAskedQuestions data={data?.faq} />}
			<RelatedContent relatedContent={RelatedContentDatra} />
		</div>
	)
}

export default BlogDescription
